import { StateToken } from '@ngxs/store';
import { DeviceStateModel } from './device.state-model';

export const STATE_TOKEN = new StateToken<DeviceStateModel>('device');
